var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_has.js
 ** module id = ./node_modules/core-js/library/modules/_has.js
 ** module chunks = 0
 **/